import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty as AntdEmpty, EmptyProps } from 'antd';
import { ReactComponent as EmptyImage } from './emptyImg.svg';

export const Empty: FC<EmptyProps> = props => {
  const { t } = useTranslation();

  return (
    <AntdEmpty
      image={<EmptyImage />}
      description={t('generic.noData')}
      {...props}
    />
  );
};
